// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"ba24e8e2","336":"4803cd60","675":"560a52ea"}[chunkId] + ".chunk.js";
};